import { Component, Input } from '@angular/core';

@Component({
	standalone: false,
	selector: 'qe-info-icon',
	templateUrl: './info-icon.component.html',
})
export class InfoIconComponent {
	@Input() public readonly variableName?: string = 'brandPrimary';

	constructor() {}
}
